import "./product-option";

const INVALID_CLASS = "product-form__option-input--invalid";

class ProductFormSelectors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => this.handleChange(e.target));

    const currentVariant = this.getAttribute("current-variant");

    if (currentVariant) {
      const data = window.scrapeSectionData(this);
      const variant = data.variants.find(
        (variant) => variant.id.toString() === currentVariant,
      );

      if (variant) {
        variant.options.forEach((optionValue, i) => {
          const optionInput = this.querySelector(
            `[data-option-index="${i}"][data-option-value="${optionValue}"]`,
          );

          optionInput.checked = true;
        });
      }
    }
  }

  disconnectedCallback() {}

  handleChange(target) {
    /* Size Guide Trigger */
    //Triggers when 'Frame Colour' variant option is changed: This is where framed / print only option lives.
    if (target.dataset.optionName === "Frame Colour") {
      //Set toggle type. 'Print Only' is it's own product. Otherwise, the toggle type is 'Framed'
      let toggleType = target.dataset.optionValue;
      if (toggleType != "Print Only") {
        toggleType = "Framed";
      }
      //Emit event to size guide modal. ToggleType is used to show framed or print chart.
      const setSizeGuideModal = new CustomEvent("setSizeGuideModal", {
        detail: { value: toggleType },
      });
      document.dispatchEvent(setSizeGuideModal);
    }
    /* End Size Guide Trigger */

    if (target.dataset.optionName === "Frame Colour") {
      this._togglePrintOnlySizeNotes(
        target.dataset.optionValue === "Print Only",
      );
    }

    this.data = window.scrapeSectionData(this);

    target.classList.remove(INVALID_CLASS);

    const selectedOptionValueId = parseInt(target.value, 10);
    const selectedOptionIndex = parseInt(target.dataset.optionIndex, 10);

    this.querySelectorAll("[data-option-value]").forEach((optionValue) => {
      const optionIndex = parseInt(optionValue.dataset.optionIndex);

      if (optionIndex === selectedOptionIndex) return;

      const optionValueId = parseInt(optionValue.value, 10);

      const valid = this.data.optionsByVariant.some((variant) => {
        const matchesSelectedOption =
          variant.variantOptions[selectedOptionIndex].id ===
          selectedOptionValueId;
        const matchesOptionValue =
          variant.variantOptions[optionIndex].id === optionValueId;

        return matchesSelectedOption && matchesOptionValue;
      });

      optionValue.classList.toggle(INVALID_CLASS, !valid);
    });

    const form = this.closest("form");

    const selectedOptionValueIds = new Array(this.data.productOptionsCount)
      .fill(null)
      .map((_, i) => parseInt(form[`option-${i + 1}`]?.value, 10));

    const matchingVariant = this.data.optionsByVariant.find((variant) =>
      selectedOptionValueIds.every(
        (selectedOptionValueId, i) =>
          selectedOptionValueId === variant.variantOptions[i].id,
      ),
    );

    let variant = null;
    let frameSizeVariants = [];

    if (matchingVariant) {
      variant = this.data.variants.find(
        (variant) => variant.id === matchingVariant.variantId,
      );

      if (this.data.productOptionsCount > 1) {
        const matchingFrameSizeVariants = this.data.optionsByVariant.filter(
          (variant) =>
            variant.variantOptions.every((variantOption, i) => {
              if (i === 0 && variantOption.id !== selectedOptionValueIds[i])
                return false;

              return true;
            }),
        );

        frameSizeVariants = matchingFrameSizeVariants.map((variant) => ({
          productOptionId: variant.variantOptions[1].id,
          variant: this.data.variants.find(
            ({ id }) => id === variant.variantId,
          ),
        }));
      }
    }

    this.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { variant, frameSizeVariants },
      }),
    );
  }

  _togglePrintOnlySizeNotes(printOnly) {
    this.querySelectorAll("[data-size-note]").forEach((sizeNote) => {
      const isPrintOnly = sizeNote.dataset.sizeNote === "print-only";
      sizeNote.style.display = printOnly === isPrintOnly ? null : "none";
    });
  }

  // setInvalidVariant() {
  //   this.setSelectedVariant("");
  //   this.querySelector("[data-product-form-atc]").disabled = true;
  // }

  // setSelectedVariant(id) {
  //   this.querySelector('[name="id"]').value = id;
  //   this.querySelector("[data-product-form-atc]").disabled = false;
  // }
}

if (!customElements.get("product-form-selectors")) {
  customElements.define("product-form-selectors", ProductFormSelectors);
}
